module.exports = __webpack_public_path__ + "static/media/contactsPink.7275ade0.svg";